<template>
    <div
        class="modal dm-modal"
        id="dm-default-modal"
        tabindex="-1"
        role="dialog"
        aria-labelledby="dm-default-modal-title"
        aria-hidden="true"
        data-hash="#modal"
        v-bind:data-backdrop="modalBlockClickAway"
        v-bind:data-keyboard="modalBlockEscPress"
    >
        <div
            class="modal-dialog modal-dialog-centered"
            role="document"
            :class="[
                isScrollable,
                modalSize,
                { 'modal-dialog--has-close-button': !hide_close_btn }
            ]"
        >
            <div class="modal-content">
                <div v-if="has_internal_overlay" class="dm-overlay"></div>
                <div class="dm-close-modal d-flex align-items-center">
                    <button
                        class="btn btn-sm btn-icon btn-light"
                        data-dismiss="modal"
                        :aria-label="translate('Close')"
                        v-if="!hide_close_btn"
                        :title="translate('Close')"
                    >
                        <i class="icon-lg las la-times"></i>
                    </button>
                </div>

                <div class="modal-header" v-if="title">
                    <h2
                        class="modal-title text-center mb-0 w-100"
                        id="dm-default-modal-title"
                    >
                        {{ title }}
                    </h2>
                </div>

                <div class="modal-body">
                    <slot></slot>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import emitter from "@/utilities/eventEmitter.js";
export default {
    components: {},

    props: [
        "title",
        "size",
        "hide_close_btn",
        "block_click_away_esc",
        "is_scrollable",
        "has_internal_overlay",
    ],

    computed: {
        modalSize() {
            if (this.size == "xl") return "modal-xl";
            if (this.size == "lg") return "modal-lg";
            if (this.size == "md") return "modal-md";
            if (this.size == "sm") return "modal-sm";

            return "modal-md";
        },

        modalBlockClickAway() {
            if (this.block_click_away_esc == "true") return "static";

            return true;
        },

        modalBlockEscPress() {
            if (this.block_click_away_esc == "true") return false;

            return true;
        },

        isScrollable() {
            if (this.is_scrollable === "false") return "";

            return "modal-dialog-scrollable";
        },
    },

    mounted() {
        $(".dm-modal").on("hide.bs.modal", function () {
            // put your default event here
            emitter.emit("emitter_modalClosed", {});
            // console.log('modal was closed');
        });
    },
};
</script>
